module.exports = __webpack_public_path__ + "img/marker_two_red1.b1bb5bff.png";